import { DraftConfiguration, PrintArea, ProductType } from '@/types';
import { getRestrictions } from '@/utils/embroideryRestrictions';
import { getBoundingBoxForRects } from '@/components/draft/utils/getBoundingBoxForRects';
import { getBoundingBoxForConfiguration } from './getBoundingBoxesForConfigurations';

export function validateEmbroideryFrame(
  configurations: DraftConfiguration[],
  productType: ProductType,
  printArea: PrintArea
): [boolean, number[]] {
  if (!configurations.length) {
    return [true, []];
  }

  const { width, height } = getBoundingBoxForRects(
    configurations.map(getBoundingBoxForConfiguration)
  );
  const [maxWidth, maxHeight] = getRestrictions(productType, printArea.id);
  const isValid = width <= maxWidth && height <= maxHeight;

  return [isValid, configurations.map(({ cid }) => cid)];
}
